var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.presentation && _vm.presentation.audioLink)?_c('div',{staticClass:"background-music"},[_c('audio',{ref:"audio-background-music",attrs:{"src":_vm.presentation.audioLink.url,"controls":"","preload":"auto","loop":true},on:{"pause":_vm.eventPause,"play":_vm.eventPlay}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }